/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Primarystudyinterest_Study_Cultural_Anthropology27Inputs */

const en__field__enum_primarystudyinterest_study_cultural_anthropology27 = /** @type {(inputs: _Field__Enum_Primarystudyinterest_Study_Cultural_Anthropology27Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cultural Anthropology and European Ethnology`)
};

const de__field__enum_primarystudyinterest_study_cultural_anthropology27 = /** @type {(inputs: _Field__Enum_Primarystudyinterest_Study_Cultural_Anthropology27Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kulturanthropologie und Europäische Ethnologie`)
};

/**
* | output |
* | --- |
* | "Cultural Anthropology and European Ethnology" |
*
* @param {_Field__Enum_Primarystudyinterest_Study_Cultural_Anthropology27Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_primarystudyinterest_study_cultural_anthropology27 = /** @type {((inputs?: _Field__Enum_Primarystudyinterest_Study_Cultural_Anthropology27Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Primarystudyinterest_Study_Cultural_Anthropology27Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_primarystudyinterest_study_cultural_anthropology27(inputs)
	return de__field__enum_primarystudyinterest_study_cultural_anthropology27(inputs)
});
export { _field__enum_primarystudyinterest_study_cultural_anthropology27 as "_field__enum_primaryStudyInterest_STUDY_CULTURAL_ANTHROPOLOGY" }